import { render, staticRenderFns } from "./PackingSlip.vue?vue&type=template&id=2c482e06&scoped=true"
import script from "./PackingSlip.vue?vue&type=script&lang=js"
export * from "./PackingSlip.vue?vue&type=script&lang=js"
import style0 from "./PackingSlip.vue?vue&type=style&index=0&id=2c482e06&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c482e06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c482e06')) {
      api.createRecord('2c482e06', component.options)
    } else {
      api.reload('2c482e06', component.options)
    }
    module.hot.accept("./PackingSlip.vue?vue&type=template&id=2c482e06&scoped=true", function () {
      api.rerender('2c482e06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/packaging/PackingSlip.vue"
export default component.exports